export enum Status {
  NO_PROCESS = 'NO_PROCESS',
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  RETRY = 'RETRY',
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS',
}
